import { render } from "./SchemaRelationsEditor.vue?vue&type=template&id=52e3a3fd&scoped=true"
import script from "./SchemaRelationsEditor.vue?vue&type=script&lang=ts"
export * from "./SchemaRelationsEditor.vue?vue&type=script&lang=ts"

import "./SchemaRelationsEditor.vue?vue&type=style&index=0&id=52e3a3fd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52e3a3fd"

export default script